<template>
  <Dropdown auto-size class="flex-grow-1">
    <template #default="{open, close}">
      <FormInput
          ref="inputRef"
          v-bind="cloneProps"
          @focus="openIfHasSuggestion(open)"
          @change="onChange"
      />
    </template>
    <template #content="{close, open}">
      <div class="suggestions">
        <Scrollbar>
          <div v-for="suggestion in suggestions"
               class="item"
               @click="select(suggestion, close)"
          >
            <span>{{ suggestion }}</span>
          </div>
        </Scrollbar>
      </div>
    </template>
  </Dropdown>
</template>
<script setup>
import Dropdown from "@/js/Elements/Dropdown.vue";
import FormInput from "@/js/Elements/Form/FormInput.vue";
import FormControlProps from "@/js/Elements/Form/FormControlProps.js";
import Scrollbar from "@/js/Elements/Scrollbar.vue";
import {ref} from "vue";

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  ...FormControlProps,
  showPassword: Boolean,
  suggestions: [Array, Object],
});
const inputRef = ref();

const cloneProps = JSON.parse(JSON.stringify(props));
cloneProps.type = 'text';
delete cloneProps.suggestions;

function onChange(value) {
  inputRef.value.setValue(value);
}

function select(suggestion, close) {
  inputRef.value.setValue(suggestion);
  close();
}

function openIfHasSuggestion(open) {
  if (Array.isArray(props.suggestions) && !props.suggestions?.length) return;
  open();
}
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";
.suggestions {
  display: flex;
  flex-direction: column;
  max-height: toRem(250);

  :deep(.scrollbar) {
    display: flex;
    flex-direction: column;
    padding: spacing(2) 0;
  }

  .item {
    width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
    padding: spacing(2);
    flex-shrink: 0;

    &:hover {
      background-color: themeColor('neutral-100');
    }

    span {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>